/**
 * Notes List widget constants.
 * Icon config for IconHighlight: notes icon with Alert (orange) bg per Figma.
 */
export const NOTE_ICON_CONFIG = Object.freeze({
  icon: 'description',
  bgColor: 'Alert',
  iconColor: 'Alert',
});

export const NOTES_CARD_MAX_CHARACTERS = 80;

export const NOTES_METADATA_ICONS = Object.freeze({
  comments: 'chat_bubble',
  attachments: 'attach_file',
  tasks: 'check_box',
});

export { NOTES_STATE_COPY } from '../../../../constants';
